import BulletpointsSection from './BulletpointsSection';
import BuyButton from './BuyButton';
import ContactSection from './ContactSection';
import FaqSection from './FaqSection';
import FeaturedCategoriesSection from './FeaturedCategoriesSection';
import FeaturedGrid from './FeaturedGrid';
import FeaturedProductsSection from './FeaturedProductsSection';
import Footer from './Footer';
import Header from './Header';
import HeaderSection from './HeaderSection';
import HeroSection from './HeroSection';
import NavCategories from './NavCategories';
import Picture from './Picture';
import ProductCard from './ProductCard';
import ProductGrid from './ProductGrid';
import ProductGridItem from './ProductGridItem';
import PromotionSection from './PromotionSection';
import SmallBuyButton from './SmallBuyButton';
import StoreSection from './StoreSection';
import TestimonialsSection from './TestimonialsSection';
import Layout from './Layout';

export {
    BulletpointsSection,
    BuyButton,
    ContactSection,
    FaqSection,
    FeaturedCategoriesSection,
    FeaturedGrid,
    FeaturedProductsSection,
    Footer,
    Header,
    HeaderSection,
    HeroSection,
    NavCategories,
    Picture,
    ProductCard,
    ProductGrid,
    ProductGridItem,
    PromotionSection,
    SmallBuyButton,
    StoreSection,
    TestimonialsSection,
    Layout
};

export default {
    BulletpointsSection,
    BuyButton,
    ContactSection,
    FaqSection,
    FeaturedCategoriesSection,
    FeaturedGrid,
    FeaturedProductsSection,
    Footer,
    Header,
    HeaderSection,
    HeroSection,
    NavCategories,
    Picture,
    ProductCard,
    ProductGrid,
    ProductGridItem,
    PromotionSection,
    SmallBuyButton,
    StoreSection,
    TestimonialsSection,
    Layout
};
